import { useEffect, useState } from "react";
import { MdDeleteForever, MdModeEdit } from "react-icons/md";
import axiosInstance from "../../api/axiosInstance.js";
import Model from "../../common/Model/index.js";
import Select from "react-select";
import { notify } from "../../common/Toast/index.js";
import { FaStarOfLife } from "react-icons/fa";

const MaterialItemTable = ({
  items,
  handleItemDelete,
  allItems,
  setItems,
  coatingColors,
  handleItemSelect,
  selectedCoatingPartyId,
  isCoatingModalOpen,
  setIsCoatingModalOpen,
  setCoatingColors,
  setIsItemModalOpen,
  isItemModalOpen,
  setAllItems,
  fetchDropdownData,
  errors,
  permission,
}) => {
  const userId = sessionStorage.getItem("userId");

  const [newCoatingColor, setNewCoatingColor] = useState({
    coating_Color_Name: "",
    coating_Color_Code: "",
  });
  const [isItemType, setIsItemType] = useState([]);
  const [isCoilData, setIsCoilData] = useState([]);
  const [isEditingCoatingColor, setIsEditingCoatingColor] = useState(false);
  const [editCoatingColorId, setEditCoatingColorId] = useState(null);
  const [newItem, setNewItem] = useState({
    item_Code: 0,
    item_Name: "",
    description: "",
    item_Rate: 0,
    item_Face: 0,
    item_Type: "",
    coil_Used: "",
    thickness: 0,
    image: null,
  });

  const filteredCoatingColors = coatingColors.filter(
    (color) => color.coating_Party_Id === Number(selectedCoatingPartyId)
  );

  const handleAddOrUpdateCoatingColor = async () => {
    try {
      const payload = {
        Coating_Color_Id: isEditingCoatingColor ? editCoatingColorId : 0,
        Coating_Party_Id: Number(selectedCoatingPartyId),
        Coating_Color_Name: newCoatingColor.coating_Color_Name,
        Coating_Color_Code: newCoatingColor.coating_Color_Code,
      };

      const apiUrl = isEditingCoatingColor
        ? "MaterialQuotation/UpdateCoatingColor"
        : "MaterialQuotation/SaveCoatingColor";

      const response = await axiosInstance.post(apiUrl, payload);

      notify(
        isEditingCoatingColor
          ? "Coating Color updated successfully!"
          : "Coating Color added successfully!",
        "success"
      );

      fetchDropdownData(
        "MaterialQuotation/GetAllCoatingColors",
        setCoatingColors
      );
      if (isEditingCoatingColor) {
        setItems((prevItems) =>
          prevItems.map((item) =>
            item.coating_Color_Id === editCoatingColorId
              ? { ...item, coating_Color_Id: editCoatingColorId }
              : item
          )
        );
      }

      setIsCoatingModalOpen(false);
      setNewCoatingColor({ coating_Color_Name: "", coating_Color_Code: "" });
      setIsEditingCoatingColor(false);
      setEditCoatingColorId(null);
    } catch (error) {
      console.error("Error adding/updating coating color:", error);
    }
  };

  const handleCoatingColorEdit = async (id) => {
    try {
      const { data } = await axiosInstance.get(
        `MaterialQuotation/GetCoatingColorById/${id}`
      );
      setNewCoatingColor({
        coating_Color_Name: data.coating_Color_Name,
        coating_Color_Code: data.coating_Color_Code,
      });
      setEditCoatingColorId(id);
      setIsEditingCoatingColor(true);
      setIsCoatingModalOpen(true);
    } catch (error) {
      console.error("Error fetching coating color:", error);
    }
  };

  const fetchItemType = async () => {
    if (isItemType.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetAllItemType`);
      setIsItemType(res.data);
    } catch (error) {
      console.error("Error fetching GetAllItemType:", error);
    }
  };
  const fetchCoilData = async () => {
    if (isCoilData.length > 0) return;
    try {
      const res = await axiosInstance.get(`Item/GetCoilMaster`);
      setIsCoilData(res.data);
    } catch (error) {
      console.error("Error fetching GetCoilMaster:", error);
    }
  };
  useEffect(() => {
    fetchItemType();
    fetchCoilData();
  }, []);

  const handleInputChange = (e) => {
    setNewItem({ ...newItem, [e.target.name]: e.target.value });
  };
  const fetchItemsData = async () => {
    try {
      const response = await axiosInstance.get("Item/GetAll");
      setAllItems(response.data);
    } catch (error) {
      console.error("Error fetching items:", error);
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formDataToSend = new FormData();
    formDataToSend.append("Item_Code", newItem.item_Code || 0);
    formDataToSend.append("Item_Name", newItem.item_Name);
    formDataToSend.append("Description", newItem.description);
    formDataToSend.append("Item_Rate", newItem.item_Rate);
    formDataToSend.append("Item_Type", parseInt(newItem.item_Type) || 0);
    formDataToSend.append("Item_Face", Number(newItem.item_Face));
    formDataToSend.append("Coil_Used", parseInt(newItem.coil_Used) || 0);
    formDataToSend.append("Thickness", Number(newItem.thickness));

    if (newItem.image) {
      formDataToSend.append("image", newItem.image);
    }

    try {
      await axiosInstance.post("Item/SaveUpdate", formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      fetchItemsData();
      setIsItemModalOpen(false);
      notify("Item added successfully!", "success");
      setNewItem({
        item_Code: "",
        item_Name: "",
        description: "",
        item_Rate: "",
        item_Type: "",
        item_Face: "",
        coil_Used: "",
        thickness: "",
        image: null,
      });

      document.getElementById("fileInput").value = "";
    } catch (err) {
      console.error("Error submitting form:", err);
    }
  };
  const itemOptions = [
    ...allItems?.map((item) => ({
      value: item.item_Code?.toString() || "",
      label: item.item_Name || "Unnamed Item",
    })),
    { value: "add-newItem", label: "+ Add New Item" },
  ];
  const colorOptions = [
    ...filteredCoatingColors.map((color) => ({
      value: color.coating_Color_Id,
      label: `${color.coating_Color_Name} `,
    })),
    { value: "add-new", label: "+ Add New Coating Color" },
  ];

  return (
    <>
      <div className="bg-white rounded-lg shadow-md mt-6">
        <div className="bg-[#f1f4f9] px-6 py-4 border-b border-gray-200 flex justify-between items-center">
          <h2 className="text-base font-semibold text-[#405189]">Item List</h2>
        </div>
        <div className="w-full overflow-x-auto p-4">
          <div className="inline-block min-w-full align-middle">
            <table className="min-w-[1400px] table-auto border-collapse border border-gray-300">
              <thead className="bg-stroke">
                <tr>
                  <th className="border border-gray px-3 py-2">No</th>
                  <th className="border border-gray px-3 py-2 w-1/4">
                    Item Name
                  </th>
                  <th className="border border-gray px-3 py-2 w-1/4">
                    Coating Color
                  </th>
                  <th className="border border-gray px-3 py-2">
                    Panel Size (MM)
                  </th>
                  <th className="border border-gray px-3 py-2">Qty</th>
                  <th className="border border-gray px-3 py-2">Total RFT</th>
                  <th className="border border-gray px-3 py-2">Rate</th>
                  <th className="border border-gray px-3 py-2">Amount</th>
                  {permission?.isDelete && (
                    <th className="border border-gray px-4 py-3 whitespace-nowrap">
                      Actions
                    </th>
                  )}
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => (
                  <tr key={index} className="text-center hover:bg-gray-50">
                    <td className="border border-gray px-4 py-2">
                      {item.seQ_NO}
                    </td>
                    <td className="border  border-gray px-4 py-2 w-1/10">
                      <Select
                        options={itemOptions}
                        value={
                          itemOptions.find(
                            (option) =>
                              String(option.value) ===
                              String(items[index]?.item_Code)
                          ) || null
                        }
                        className="min-w-[200px]"
                        menuPortalTarget={document.body}
                        isClearable
                        isSearchable
                        onChange={(selectedOption) =>
                          handleItemSelect(index, selectedOption, "item_Code")
                        }
                        name="item_Code"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            borderColor: "gray",
                            boxShadow: "none",
                            "&:hover": { borderColor: "gray" },
                          }),
                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                          menu: (provided) => ({
                            ...provided,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                          menuList: (provided) => ({
                            ...provided,
                            maxHeight: "200px",
                            overflowY: "auto",
                          }),
                          option: (provided, { data }) => ({
                            ...provided,
                            backgroundColor:
                              data.value === "add-newItem"
                                ? "#F3F4F6"
                                : provided.backgroundColor,
                            fontWeight:
                              data.value === "add-newItem" ? "bold" : "normal",
                            cursor: "pointer",
                            position:
                              data.value === "add-newItem"
                                ? "sticky"
                                : "relative",
                            bottom: data.value === "add-newItem" ? "0" : "auto",
                          }),
                        }}
                      />
                    </td>
                    <td className="border border-gray px-3 py-2 min-w-[200px]">
                      <div className="flex items-center gap-2">
                        <div className="flex-1">
                          <Select
                            options={colorOptions}
                            value={
                              colorOptions.find(
                                (option) =>
                                  option.value ===
                                  items[index]?.coating_Color_Id
                              ) || null
                            }
                            menuPortalTarget={document.body}
                            isClearable
                            isSearchable
                            onChange={(selectedOption) =>
                              handleItemSelect(
                                index,
                                selectedOption,
                                "coating_Color_Id"
                              )
                            }
                            name="coating_Color_Id"
                            styles={{
                              control: (provided) => ({
                                ...provided,
                                borderColor: "gray",
                                boxShadow: "none",
                                "&:hover": { borderColor: "gray" },
                              }),
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              menu: (provided) => ({
                                ...provided,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: "200px",
                                overflowY: "auto",
                              }),
                              option: (provided, { data }) => ({
                                ...provided,
                                backgroundColor:
                                  data.value === "add-new"
                                    ? "#F3F4F6"
                                    : provided.backgroundColor,
                                fontWeight:
                                  data.value === "add-new" ? "bold" : "normal",
                                cursor: "pointer",
                                position:
                                  data.value === "add-new"
                                    ? "sticky"
                                    : "relative",
                                bottom: data.value === "add-new" ? "0" : "auto",
                              }),
                            }}
                          />
                        </div>
                        {items[index]?.coating_Color_Id && (
                          <button
                            type="button"
                            onClick={() =>
                              handleCoatingColorEdit(
                                items[index]?.coating_Color_Id
                              )
                            }
                            className="text-primary"
                          >
                            <MdModeEdit />
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="border border-gray px-3 py-2">
                      <input
                        type="text"
                        className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                        name="panel_Size"
                        value={items[index]?.panel_Size || ""}
                        onChange={(e) => handleItemSelect(index, e)}
                      />
                    </td>
                    <td className="border border-gray px-3 py-2">
                      <input
                        type="text"
                        className="border rounded p-2 w-full outline-none focus:ring-2 focus:ring-primary"
                        name="qty"
                        value={items[index]?.qty || ""}
                        onChange={(e) => handleItemSelect(index, e)}
                      />
                    </td>
                    <td className="border border-gray px-3 py-2">
                      {item.total_RfT.toFixed(2)}
                    </td>
                    <td className="border border-gray px-3 py-2">
                      <input
                        type="text"
                        className="p-2 rounded w-full border outline-none focus:ring-2 focus:ring-primary "
                        name="rate"
                        value={items[index]?.rate || ""}
                        onChange={(e) => handleItemSelect(index, e)}
                        disabled={userId !== "1" && userId !== "19"}
                      />
                    </td>

                    <td className="border border-gray px-3 py-2">
                      {item.amount.toFixed(2)}
                    </td>
                    {permission?.isDelete && (
                      <td className="border border-gray px-3 py-2">
                        <button
                          type="button"
                          className="ml-2 px-3 py-2 text-sm font-medium text-danger bg-red-100 rounded-md hover:bg-red-200 outline-none focus:ring-2 focus:ring-red-500"
                          onClick={() =>
                            handleItemDelete(index, item.item_Code, item.seQ_NO)
                          }
                        >
                          <MdDeleteForever className="w-5 h-5" />
                        </button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <button
          type="button"
          className="px-4 py-2 text-sm font-medium  text-white bg-secondary rounded-md m-6"
          onClick={() =>
            setItems((prevItems) => [
              ...prevItems,
              {
                item_Code: "",
                item_Name: "",
                coating_Color_Id: "",
                panel_Size: "",
                qty: "",
                total_RfT: 0,
                rate: 0,
                amount: 0,
                seQ_NO: prevItems.length + 1,
              },
            ])
          }
        >
          + Add Item
        </button>

        {errors.items && (
          <p className="text-red-500 text-xs mt-1">{errors.items}</p>
        )}
      </div>
      <Model
        isOpen={isCoatingModalOpen}
        onClose={() => setIsCoatingModalOpen(false)}
        name="Add Coating Color"
      >
        <div className="p-4 space-y-4">
          <input
            type="text"
            placeholder="Coating Color Name"
            className="border p-2 w-full"
            value={newCoatingColor.coating_Color_Name}
            onChange={(e) =>
              setNewCoatingColor((prev) => ({
                ...prev,
                coating_Color_Name: e.target.value,
              }))
            }
          />
          <input
            type="text"
            placeholder="Coating Color Code"
            className="border p-2 w-full"
            value={newCoatingColor.coating_Color_Code}
            onChange={(e) =>
              setNewCoatingColor((prev) => ({
                ...prev,
                coating_Color_Code: e.target.value,
              }))
            }
          />
          <button
            type="button"
            onClick={handleAddOrUpdateCoatingColor}
            className="px-4 py-2 text-sm font-medium rounded bg-primary text-white"
          >
            {isEditingCoatingColor ? "Update" : "Add"}
          </button>
          <button
            type="button"
            onClick={() => setIsCoatingModalOpen(false)}
            className="px-4 py-2 border border-gray text-sm font-medium rounded bg-white ml-4"
          >
            Cancel
          </button>
        </div>
      </Model>
      <Model
        isOpen={isItemModalOpen}
        onClose={() => setIsItemModalOpen(false)}
        name="Add New Item"
      >
        <div className="space-y-4">
          <div>
            <label className="flex items-center text-sm font-medium mb-2">
              Item Name
              <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
            </label>
            <input
              type="text"
              name="item_Name"
              value={newItem.item_Name || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter item name"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <input
              type="text"
              name="description"
              value={newItem.description || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter item description"
            />
          </div>

          <div>
            <label className="flex items-center text-sm font-medium mb-2">
              Item Rate
              <FaStarOfLife className="text-red-500 ml-1 w-2 h-2" />
            </label>
            <input
              type="text"
              name="item_Rate"
              value={newItem.item_Rate || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter item rate"
            />
            {errors.item_Rate && (
              <p className="text-red-500 text-xs mt-1">{errors.item_Rate}</p>
            )}
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Item Face
            </label>
            <input
              type="text"
              name="item_Face"
              value={newItem.item_Face || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter item face"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Item Type
            </label>
            <select
              className="w-full px-3 py-2 border rounded-md"
              name="item_Type"
              value={newItem.item_Type}
              onChange={handleInputChange}
            >
              <option value="">Select Item Type</option>
              {isItemType.map((item) => (
                <option key={item.item_Type} value={item.item_Type}>
                  {item.item_Type_Name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Coil Used
            </label>
            <select
              className="w-full px-3 py-2 border rounded-md"
              name="coil_Used"
              value={newItem.coil_Used}
              onChange={handleInputChange}
            >
              <option value="">Select Coil Type</option>
              {isCoilData.map((coil) => (
                <option key={coil.coil_Used} value={coil.coil_Used}>
                  {coil.coil_Name}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Thickness
            </label>
            <input
              type="text"
              name="thickness"
              value={newItem.thickness || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter thickness"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Upload Image
            </label>
            <input
              type="file"
              name="image"
              value={newItem.image || ""}
              onChange={handleInputChange}
              className="w-full px-3 py-2 border rounded-md"
              placeholder="Enter thickness"
            />
          </div>
        </div>

        <div className="flex justify-end space-x-4 mt-4">
          <button
            type="button"
            onClick={handleSubmit}
            className="px-4 py-2 text-sm font-medium rounded bg-primary text-white"
          >
            Save
          </button>
          <button
            type="button"
            onClick={() => setIsItemModalOpen(false)}
            className="px-4 py-2 border border-gray text-sm font-medium rounded bg-white"
          >
            Cancel
          </button>
        </div>
      </Model>
    </>
  );
};

export default MaterialItemTable;
